import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { ManageSurveyReferenceActions } from './manage-survey-reference.actions';

@Injectable({ providedIn: 'root' })
export class ManageSurveyReferenceActionsFacade {
  private readonly _store = inject(Store);

  public loadSupplierAllocations(surveyId: number): void {
    this._store.dispatch(
      ManageSurveyReferenceActions.loadSupplierAllocations({ surveyId }),
    );
  }
}
